import { __awaiter, __decorate, __extends, __generator } from "tslib";
import React from 'react';
import { getRecommendations, getRecommendationsFromML, getTagsDataBySlugs, } from '../../../../api/api';
import { SolutionsGrid } from './solutions-grid';
import { withExperiments } from '../../../../component-decorators/with-experiments';
import { withMarketplaceStore, } from '../../../../component-decorators/with-marketplace-store';
import { biLogger } from '../../../../bi';
import { v4 as generateUuidV4 } from 'uuid';
export var dtoToGridsSolutions = function (solutionDto) {
    var webSolutionsBase = solutionDto.company && solutionDto.company.webSolutions
        ? solutionDto.company.webSolutions.map(companySolutionsToBaseInfo)
        : undefined;
    return {
        appId: solutionDto.baseInfo.id,
        solutions: webSolutionsBase,
    };
};
var SolutionsGridContainer = /** @class */ (function (_super) {
    __extends(SolutionsGridContainer, _super);
    function SolutionsGridContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFetching: true,
        };
        return _this;
    }
    SolutionsGridContainer.prototype.render = function () {
        return (React.createElement("div", null, this.state.isFetching ? null : (React.createElement(SolutionsGrid, { solutions: this.state.solutions, referralSectionName: this.state.referralSectionName, collimp_id: this.state.collimp_id, referralInfo: 'may_also_like' }))));
    };
    SolutionsGridContainer.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(prevProps.appId !== this.props.appId)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.initialize(this.props.locale, this.props.countryCode)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    SolutionsGridContainer.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.initialize(this.props.locale, this.props.countryCode)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SolutionsGridContainer.prototype.initialize = function (locale, countryCode) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function () {
            var useInReview, solutions, webSolutionsBase, webSolutions, referralSectionName, fetchRecommendationsFromML, signedInstance, _g, webSolutions_1, appIds, appIdsList, collimp_id;
            var _this = this;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        useInReview = (_a = this.props.experiments) === null || _a === void 0 ? void 0 : _a.enabled('specs.marketplace.UseInReview');
                        fetchRecommendationsFromML = (_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.experiments) === null || _c === void 0 ? void 0 : _c.enabled('specs.marketplace.useMLInManageAndAppPage');
                        if (!this.props.marketplaceStore.metaSiteId) return [3 /*break*/, 5];
                        signedInstance = (_e = (_d = this.props) === null || _d === void 0 ? void 0 : _d.getAppInstance) === null || _e === void 0 ? void 0 : _e.call(_d, '22bef345-3c5b-4c18-b782-74d4085112ff');
                        if (!fetchRecommendationsFromML) return [3 /*break*/, 2];
                        return [4 /*yield*/, getRecommendationsFromML('10', locale, signedInstance)];
                    case 1:
                        _g = _h.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, getRecommendations(signedInstance, locale)];
                    case 3:
                        _g = _h.sent();
                        _h.label = 4;
                    case 4:
                        webSolutions = _g;
                        webSolutionsBase = fetchRecommendationsFromML ? (_f = webSolutions.webSolutions) === null || _f === void 0 ? void 0 : _f.map(function (sol) { return sol.baseInfo; }) : webSolutions.map(function (sol) { return sol.baseInfo; });
                        solutions = webSolutionsBase
                            .filter(function (solution) { return solution.id !== _this.props.appId; })
                            .slice(0, 4);
                        referralSectionName = fetchRecommendationsFromML ? 'may_also_like_ML' : 'may_also_like';
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, getTagsDataBySlugs(['staff-picks'], useInReview, locale, countryCode, true, true)];
                    case 6:
                        webSolutions_1 = (_h.sent()).webSolutions;
                        webSolutionsBase = webSolutions_1.map(function (sol) { return sol.baseInfo; });
                        solutions = webSolutionsBase
                            .filter(function (solution) { return solution.id !== _this.props.appId; })
                            .slice(0, 4);
                        _h.label = 7;
                    case 7:
                        appIds = solutions.map(function (webSolution) { return webSolution.id; });
                        appIdsList = appIds === null || appIds === void 0 ? void 0 : appIds.join(',');
                        collimp_id = generateUuidV4();
                        biLogger.appMarketAppCollectionImpressions({
                            apps_list: appIdsList,
                            collimp_id: collimp_id,
                            number_of_apps: 4,
                            tag_name: 'user-recommendations',
                            tag_type: 'app_page',
                            prediction_type: fetchRecommendationsFromML ? webSolutions === null || webSolutions === void 0 ? void 0 : webSolutions.predictionType : 'old_rec'
                        })
                            .catch(function (e) { return console.log(e); });
                        this.setState({ isFetching: false, solutions: solutions, collimp_id: collimp_id, referralSectionName: referralSectionName });
                        return [2 /*return*/];
                }
            });
        });
    };
    SolutionsGridContainer = __decorate([
        withMarketplaceStore,
        withExperiments
    ], SolutionsGridContainer);
    return SolutionsGridContainer;
}(React.Component));
export { SolutionsGridContainer };
export var companySolutionsToBaseInfo = function (solution) {
    var id = solution.id, name = solution.name, teaser = solution.teaser, icon = solution.icon, type = solution.type, description = solution.description, slug = solution.slug, pricing = solution.pricing, company = solution.company, reviewStars = solution.reviewStars, numberOfReviews = solution.numberOfReviews, Tags = solution.Tags, openConsentIn = solution.openConsentIn;
    return {
        id: id,
        name: name,
        teaser: teaser,
        icon: icon,
        type: type,
        description: description,
        slug: slug,
        pricing: pricing,
        company: company,
        reviewStars: reviewStars,
        numberOfReviews: numberOfReviews,
        Tags: Tags,
        openConsentIn: openConsentIn,
    };
};
//# sourceMappingURL=solutions-grid-container.js.map